/**
 * Created by slava on 8/8/17
 */

const BaseBooster = function (id) {
    cleverapps.EventEmitter.call(this);
    this.id = id;

    const data = cleverapps.Boosters.CONFIG[id];
    this.type = data.type;
    this.force = data.force;
    this.available = data.available;
    this.icon = data.icon;
    this.limit = data.limit;
    this.executeEffect = data.executeEffect || "ui.button.click";
};

BaseBooster.prototype = Object.create(cleverapps.EventEmitter.prototype);
BaseBooster.prototype.constructor = BaseBooster;

BaseBooster.prototype.onGameStarted = function () {

};

BaseBooster.prototype.isDisabled = function () {
    return !levels.user.checkAvailable(this.available);
};

BaseBooster.prototype.getPrice = function () {
    if (!this.type) {
        return;
    }

    return { amount: cleverapps.Boosters.getPrice(this.type) };
};

BaseBooster.prototype.getAmount = function () {
    return cleverapps.boosters.getAmount(this.id);
};

BaseBooster.prototype.setAmount = function (amount) {
    return cleverapps.boosters.setAmount(this.id, amount);
};

BaseBooster.prototype.onChange = function () {
    this.trigger("changeAmount");
};

BaseBooster.prototype.buy = function () {
    const eventName = `${cleverapps.EVENTS.SPENT.BOOSTER}_${this.type}`;
    const bought = cleverapps.user.spendHard(eventName, this.getPrice().amount);

    if (bought) {
        cleverapps.boosters.add(this.id, 1);
    }

    return bought;
};

BaseBooster.prototype.use = function (useType) {
    if (cleverapps.boosters.has(this.id) || this.isFreePrice) {
        if (!this.isFreePrice) {
            cleverapps.boosters.take(this.id);
        }

        this.logUseEvents(useType);

        this.onUsed();
    }
};

BaseBooster.prototype.logUseEvents = function (useType) {
    const statsParams = Game.currentGame ? Game.currentGame.getLevelStatsParams() : {};
    statsParams.value = this.getPrice().amount;

    cleverapps.metrics.logEvent(cleverapps.EVENTS.HINT_USED, statsParams);
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTERS_EXECUTE}_${this.id}`);
    cleverapps.metrics.logEvent(`${cleverapps.EVENTS.BOOSTERS_USE}_${this.type}_${useType}`);
};

BaseBooster.prototype.onUsed = function () {
    cleverapps.eventBus.trigger("taskEvent", "USE_BOOSTER");
    cleverapps.eventBus.trigger("use_booster", { id: this.id });
};

BaseBooster.prototype.execute = function () {
    this.use();
};

BaseBooster.prototype.canExecute = function () {
    return cleverapps.boosters.has(this.id) || this.isFreePrice;
};

BaseBooster.prototype.isAdsAvailable = function () {
    const price = this.getPrice().amount;
    return this.limit && cleverapps.adsLimits.state(this.limit) === AdsLimits.STATE_READY && !cleverapps.user.canTakeHard(price);
};

BaseBooster.prototype.isForceAvailable = function () {
    return this.isAvailable() && !cleverapps.forces.isShown(this.force);
};

BaseBooster.prototype.isAvailable = function () {
    return !cleverapps.gameModes.noBoosters && levels.user.checkAvailable(this.available);
};

BaseBooster.prototype.getState = function () {
    if (cleverapps.boosters.has(this.id)) {
        return BaseBooster.AMOUNT_STATE;
    } if (this.isAdsAvailable()) {
        return BaseBooster.ADS_STATE;
    }
    return BaseBooster.PRICE_STATE;
};

BaseBooster.prototype.getControlId = function () {
    return `hint_${this.id}`;
};

BaseBooster.prototype.setFreePrice = function () {
    this.isFreePrice = true;
    this.trigger("freePrice");
};

BaseBooster.prototype.setRegularPrice = function () {
    this.isFreePrice = false;
    this.trigger("regularPrice");
};

BaseBooster.AMOUNT_STATE = 0;
BaseBooster.ADS_STATE = 1;
BaseBooster.PRICE_STATE = 2;
